import React, { useMemo } from 'react';
import { useTranslate } from 'react-admin';
import { useAllServicesQuery } from '~/hooks/paymentServices';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import { PaymentService } from '~/types/paymentServices';

interface Props {
  onChange: (e: any) => void;
  value: string | undefined;
  name?: string; // In case if needed
  label?: string; // In case if needed
  [x: string]: any;
}

const ServiceInput = (props: Props) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.headTransactions.list.filters.${key}`);

  const { data: services } = useAllServicesQuery();

  const servicesMap: Record<string, PaymentService> = useMemo(() => {
    if (services && !isEmpty(services)) {
      return services.reduce((acc, service) => ({ ...acc, [service.id]: service }), {});
    } else {
      return {};
    }
  }, [services]);

  return (
    <Autocomplete
      options={Object.keys(servicesMap)}
      className={props.className}
      disabled={props.disabled}
      autoHighlight
      getOptionLabel={(serviceId) => {
        const service = servicesMap[serviceId];
        return service ? `${service.name} (${service.id})` : '';
      }}
      renderOption={(serviceId) => {
        const service = servicesMap[serviceId];
        return (
          <div style={{ overflowWrap: 'anywhere' }}>
            {service ? `${service.name} (${service.id})` : ''}
          </div>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label || t('paymentService')}
          variant='filled'
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off', // disable autocomplete and autofill
          }}
          fullWidth
          required={props.required}
          helperText={props.helperText}
          error={props.error}
          style={props.style}
        />
      )}
      // I guess react-admin approach to searching is OK. but if there are any bugs, you can uncomment the code below.
      // filterOptions={createFilterOptions({
      //   stringify: (serviceId) => `${servicesMap[serviceId]?.name}${serviceId}`,
      // })}
      value={props.value}
      onChange={(e: any, option: any) => {
        props.onChange &&
          props.onChange({
            target: {
              name: props.name,
              value: option,
            },
          });
      }}
      noOptionsText={translate('utils.noOptions')}
    />
  );
};

export default ServiceInput;
